<div ngbDropdown class="rs-common-dropdown rs-dropdown-user rs-dropdown-icon" *ngIf="showUserSection">
    <a class="nav-link" id="userDropdownMenuButton" role="button" ngbDropdownToggle>
        <span class="rs-button-icon rs-user"></span>
    </a>
    <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="userDropdownMenuButton">
        <a class="dropdown-item" routerLink="/user-profile">{{'userOptionsComponent.profile' | translate}}</a>
        <a class="dropdown-item" (click)="logout()">{{ 'userOptionsComponent.logout' | translate }}</a>
    </div>
</div>